import { render } from "./PopupDialog.vue?vue&type=template&id=f732e960&scoped=true"
import script from "./PopupDialog.vue?vue&type=script&lang=js"
export * from "./PopupDialog.vue?vue&type=script&lang=js"

import "./PopupDialog.vue?vue&type=style&index=0&id=f732e960&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f732e960"

export default script